var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-wizard-button',{attrs:{"disabled":_vm.busy,"busy":_vm.busy},on:{"click":_vm.startAutoMapping}},[_vm._v("Automatische Verknüpfung starten")])}
var staticRenderFns = []

export { render, staticRenderFns }